// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1hNog","header":"MessagesList_header__2cug_","chat":"MessagesList_chat__21pMc"};